const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      link: '.js-toggle',
    };

    this.classes = {
      open: 'is-open',
    };

    $(document).ready(() => {
      this.init();
    });
  }

  init() {
    this.bindClickEvent();
  }

  bindClickEvent() {
    const link = $(this.selectors.link);
    link.on('click', event => {
      event.preventDefault();

      const target = link.toggleClass('is-open').attr('data-content');
      const $target = $(`#${target}`);
      $target.toggleClass(this.classes.open);
      $target.parent().toggleClass(this.classes.open);
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/toggle.js